import React, { useState } from "react";
import { Backdrop, Box } from "@mui/material";
import axios from "axios";

import { BackdropSection, LoaderStyle } from "../styles/styles";
import { tangoLogoLoader } from "../../constants/ImagePaths";
import { Constants } from "../../constants/Referral";

function CentralLoader() {
  const [loading, setLoading] = useState(true);
  const [isDocUploadIsPending, setIsDocUploadIsPending] = useState(false);

  let numberOfAjaxCAllPending = 0;

  axios.interceptors.request.use(
    function (config) {
      numberOfAjaxCAllPending++;
      if (config.url?.includes(Constants.DOCUMENT_UPLOAD_URL) ||
          config.url?.includes(Constants.INJEST_PROCESS_URL)) { 
        setIsDocUploadIsPending(true);
      }

      if (
        !loading &&
        !config.url?.includes(Constants.IcdDiagnosisType) &&
        !config.url?.includes(Constants.UPLOAD_TRAINING_VIDEO_URL) &&
        !config.url?.includes(Constants.SHOW_NOTIFICATION_PANEL) &&
        !config.url?.includes(Constants.VIEWED_NOTIFICATION) &&
        !config.url?.includes(Constants.DOWNLOAD_DOCUMENT_OF_NOTIFICATION)
      ) {
        setLoading(true);
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function (response) {
      numberOfAjaxCAllPending--;
      if (response.config?.url?.includes(Constants.DOCUMENT_UPLOAD_URL) && response.status === 200) {
        setIsDocUploadIsPending(false);
      }
      setTimeout(() => { 
        if (Number(numberOfAjaxCAllPending) === 0 && !isDocUploadIsPending) {
        setLoading(false);
      }
      }, 200);
      
      return response;
    },
    function (error) {
      numberOfAjaxCAllPending--;
      if (Number(numberOfAjaxCAllPending) === 0) {
        setLoading(false);
      }
      return Promise.reject(error);
    }
  );
  const spinAnimation = `
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

  React.useEffect(() => {
    if (loading) {
      const style = document.createElement("style");
      style.innerHTML = spinAnimation;
      document.head.appendChild(style);
    }
  }, [loading]);
  return (
    <Backdrop sx={BackdropSection} open={loading}>
      <Box
        component="img"
        src={tangoLogoLoader}
        alt="loading"
        sx={LoaderStyle}
      />
    </Backdrop>
  );
}

export default CentralLoader;
